// src/pages/IntakeHub/caseHistoryApi.js
// Every Case History call in one place, so screens don't hard-code paths.
import api from '../../services/api';

export const listCases = (mine) => api.get('/case-history/cases', { params: mine ? { mine: true } : {} });
export const getCase = (caseId) => api.get(`/case-history/cases/${caseId}`);
export const getConsentState = (childId) => api.get(`/consent/state/${childId}`);
export const listTherapists = () => api.get('/case-history/therapists');
export const listEligibleChildren = () => api.get('/case-history/eligible-children');
export const createChildWithCase = (body) => api.post('/case-history/children', body);
export const startCaseForChild = (childId, body) => api.post(`/case-history/children/${childId}/cases`, body);

// RPwD Act 2016 categories, shortened to the ones this service sees.
export const DISABILITY_OPTIONS = [
    { value: 'speech_language', label: 'Speech & language' },
    { value: 'hearing', label: 'Hearing' },
    { value: 'intellectual', label: 'Intellectual' },
    { value: 'cerebral_palsy', label: 'Cerebral palsy' },
    { value: 'autism', label: 'Autism spectrum' },
    { value: 'locomotor', label: 'Locomotor' },
    { value: 'visual', label: 'Visual' },
    { value: 'multiple', label: 'Multiple' },
    { value: 'other', label: 'Other' },
];

export const LANGUAGES = ['Hindi', 'English', 'Marathi', 'Gujarati', 'Tamil', 'Telugu', 'Kannada', 'Bengali', 'Other'];

export function ageLabel(months) {
    if (months === null || months === undefined) return '';
    return `${Math.floor(months / 12)} y ${months % 12} m`;
}

// The five case-card segments, in the order they happen.
export const SEGMENTS = [
    ['history', 'History'],
    ['consent', 'Consent'],
    ['capture', 'Capture'],
    ['clinical', 'Clinical'],
    ['sign_off', 'Sign-off'],
];
